<template>
  <a-form :model="formModel" layout="vertical" :disabled="loading">
    <a-form-item label="Объект редактирования" name="type">
      <a-select
        :options="options"
        v-model:value="labelTemplateFormState.selectedLabelTemplateObject"
        @dropdownVisibleChange="dropDownOpen = $event"
        :open="dropDownOpen"
      >
        <template #option="{ label, value }">
          <a-flex class="menu-item">
            <a-typography-text>
              {{ label }}
            </a-typography-text>

            <a-button
              danger
              :icon="h(DeleteOutlined)"
              @click="deleteItem($event, value)"
            ></a-button>
          </a-flex>
        </template>

        <template #dropdownRender="{ menuNode }">
          <div>
            <component :is="menuNode" />

            <a-button
              type="primary"
              @click="addItem"
              :icon="h(PlusOutlined)"
              block
              class="add-button"
            >
              Добавить
            </a-button>
          </div>
        </template>
      </a-select>
    </a-form-item>
  </a-form>
</template>

<script setup lang="ts">
import { useLabelTemplateFormStore } from "@/stores/labelTemplate/labelTemplateFormStore";
import { storeToRefs } from "pinia";
import { computed, h, ref, watch } from "vue";
import {
  LabelObjectPlainTextPosition,
  LabelTemplateObjectType,
  LabelTemplateTextType,
} from "@/api/classes/labelTemplate/labelTemplate.dto";
import {
  DomainObjectPropertyTypeTranslation,
  LabelTemplateBarcodeTypeTranslation,
  LabelTemplateObjectTypeTranslation,
} from "@/api/classes/labelTemplate/labelTemplateTranslates";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons-vue";

defineProps<{ loading: boolean }>();

const labelTemplateFormState = useLabelTemplateFormStore();

const dropDownOpen = ref<boolean>(false);

const { selectedLabelTemplateObject } = storeToRefs(labelTemplateFormState);

const formModel = computed(() => ({
  type: selectedLabelTemplateObject.value,
}));

const options = computed(() =>
  labelTemplateFormState.currentLabelTemplateObjects.map((item, index) => {
    let label = LabelTemplateObjectTypeTranslation[item.objectType];

    if (item.objectType === LabelTemplateObjectType.Text) {
      if (item.textType === LabelTemplateTextType.PlainText) {
        label = item.plainText;
      }

      if (
        item.textType === LabelTemplateTextType.DomainObjectProperty &&
        item.domainObjectPropertyTypes?.length
      ) {
        const domains = item.domainObjectPropertyTypes
          .map((domain) => DomainObjectPropertyTypeTranslation[domain])
          .filter(Boolean)
          .join(", ");

        label = (item.plainText || "Текст") + `(${domains || "свойства"})`;

        if (item.plainTextPosition === LabelObjectPlainTextPosition.Right) {
          label = `(${domains || "свойства"})` + (item.plainText || "Текст");
        }
      }

      if (!label) {
        label = "Текст";
      }
    }

    if (item.objectType === LabelTemplateObjectType.Barcode) {
      label =
        label + ` (${LabelTemplateBarcodeTypeTranslation[item.barcodeType]})`;
    }

    const value = labelTemplateFormState.getLabelTemplateObjectStringId(
      item,
      index,
    );

    return { value, label };
  }),
);

const deleteItem = (event: Event, value: string) => {
  event.preventDefault();
  event.stopPropagation();

  labelTemplateFormState.deleteLabelTemplateObject(value);
};

const addItem = () => {
  labelTemplateFormState.addLabelTemplate();

  dropDownOpen.value = false;
};

watch(
  () => selectedLabelTemplateObject.value,
  (value) => {
    if (value) {
      const obj =
        labelTemplateFormState.getLabelTemplateObjectDataFromStringId(value);

      labelTemplateFormState.selectLabelTemplateObject(obj);
    }
  },
);
</script>

<style scoped lang="scss">
.menu-item {
  .ant-typography {
    flex-grow: 1;
    line-height: 1;
    align-items: center;
    display: flex;
  }

  .ant-btn-icon-only {
    padding: 5px;
    border: none;
    background: none;
    box-shadow: none;
  }
}

.add-button {
  margin-top: 10px;
  justify-self: center;
}
</style>
